import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { getPublicSession } from '../../publicSession/selectors';
import { attemptSocialLogin } from '../redux/actions';
import { Props } from './SocialButtonApple';

type StateProps = Pick<Props, 'clientId' | 'sessionId'>;
type DispatchProps = Pick<Props, 'attemptSocialLogin'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => {
  const session = getPublicSession(state);
  return {
    clientId: session.appIds?.appleAppId || '',
    sessionId: session.sessionId,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  attemptSocialLogin,
};

export default connect(mapStateToProps, mapDispatchToProps);
